import isEmpty from 'lodash/fp/isEmpty';
import isUndefined from 'lodash/fp/isUndefined';
import type { Address as AddressV3, Coordinates as CoordinatesApi } from '../store/facade/facadeApiV3';
import { DEFAULT_LOCALE } from '../store/lang/lang';
import type { Coordinates, Coords } from './types';

const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const translateWeekday = (locale: string | undefined) => {
    const weekdaysTanslated = WEEKDAYS.map((weekday: string, index: number) => {
        if (index < 0) {
            throw new Error(`Unknown weekday "${weekday}"`);
        }

        const dummyDate = new Date(2001, 0, index);

        return dummyDate.toLocaleDateString(locale ?? DEFAULT_LOCALE, { weekday: 'long' });
    });
    return weekdaysTanslated;
};

export const coordinatesToCoords = (position: Coordinates | CoordinatesApi): Coords => ({
    lat: position.latitude,
    lng: position.longitude,
});

export const coordsToCoordinates = (position: Coords): Coordinates => ({
    latitude: position.lat,
    longitude: position.lng,
});

export const formatAddress = (address?: string, postalCode?: string, city?: string, name?: string) => {
    const resolvedAddress = !isUndefined(address) && address !== '' ? address : name;
    return [city, resolvedAddress, postalCode].filter(it => !isUndefined(it) && it !== '').join(', ');
};

export const getFullAddressLabel = (address: AddressV3 | undefined): string | undefined => {
    if (isUndefined(address)) {
        return;
    }

    const { name, street, number: houseNumber, city, countryCode, postalCode } = address;

    const hasStreet = !isEmpty(street);
    const hasNumber = !isEmpty(houseNumber);

    let streetAndNumber: string | undefined;
    if (hasStreet || hasNumber) {
        streetAndNumber = [street, houseNumber].filter(it => !isEmpty(it)).join(' ');
    } else if (!isEmpty(name)) {
        streetAndNumber = name;
    }

    const fullAddressArray = [streetAndNumber, postalCode, city, countryCode];

    return fullAddressArray.filter(it => !isEmpty(it)).join(', ');
};
